import script from "./base-modal.vue?vue&type=script&setup=true&lang=ts"
export * from "./base-modal.vue?vue&type=script&setup=true&lang=ts"

import "./base-modal.vue?vue&type=style&index=0&id=42ab0f8c&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-42ab0f8c"]])

export default __exports__